import { Toaster } from 'react-hot-toast';

import { ApolloProvider } from '@apollo/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { init18n } from '@spacefill/shared/src/i18n/I18n';
import { client as ApolloClient } from '@spacefill/shared/src/utils/Apollo';
import { FeatureTogglingProvider } from '@spacefill/shared/src/utils/FeatureToggling';
import { SideBarContextProvider } from '@spacefill/shared/src/utils/contexts/SideBarContext';
import { TopBannerContextProvider } from '@spacefill/shared/src/utils/contexts/TopBannerContext';
import { UserProvider } from '@spacefill/shared/src/utils/contexts/UserContext';

import { RouterContext } from './router/RouterContext';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

init18n();

const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <ApolloProvider client={ApolloClient}>
                <FeatureTogglingProvider>
                    <TopBannerContextProvider>
                        {/* Just for removing `constate` warning */}
                        <SideBarContextProvider>
                            <UserProvider>
                                <RouterContext />
                                <Toaster />
                            </UserProvider>
                        </SideBarContextProvider>
                    </TopBannerContextProvider>
                </FeatureTogglingProvider>
            </ApolloProvider>
            {import.meta.env?.VITE_EXTERNAL_CONSOLE_REACT_QUERY_DEVTOOLS_ENABLED && (
                <ReactQueryDevtools initialIsOpen />
            )}
        </QueryClientProvider>
    );
};

export { App };
